import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from '../../components/header/header';
import { Sidebar } from '../../components/sidebar/sidebar';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    Header, 
    Sidebar,
    RouterOutlet
  ],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home {}